import { createSlice } from "@reduxjs/toolkit";

export const realWeddingSlice = createSlice({
  name: "realWedding",
  initialState: {
    getListLoading: false,
    getListError: false,
    getListData: null,
    getListMessage: "",
    getListStatusCode: 0,
    getOneLoading: false,
    getOneError: false,
    getOneData: null,
    getOneMessage: "",
    getOneStatusCode: 0,
    postLoading: false,
    postError: false,
    postData: null,
    postMessage: "",
    postStatusCode: 0,
  },
  reducers: {
    onGetRealWeddings: (state) => ({
      ...state,
      getListLoading: true,
      getListError: false,
      getListData: null,
      getListMessage: "",
      getListStatusCode: 0,
    }),
    onGetRealWeddingsSuccess: (state, { payload }) => {
      const { data = null, message = "", status_code = 200 } = payload ?? {};
      return {
        ...state,
        getListLoading: false,
        getListError: false,
        getListData: data,
        getListMessage: message,
        getListStatusCode: status_code,
      };
    },
    onGetRealWeddingsError: (state, { payload }) => {
      const { data = null, message = "", status_code = 400 } = payload ?? {};
      return {
        ...state,
        getListLoading: false,
        getListError: true,
        getListData: data,
        getListMessage: message,
        getListStatusCode: status_code,
      };
    },
    onGetRealWeddingsReset: (state) => ({
      ...state,
      getListLoading: false,
      getListError: false,
      getListData: null,
      getListMessage: "",
      getListStatusCode: 0,
    }),
    onGetRealWedding: (state) => ({
      ...state,
      getOneLoading: true,
      getOneError: false,
      getOneData: null,
      getOneMessage: "",
      getOneStatusCode: 0,
    }),
    onGetRealWeddingSuccess: (state, { payload }) => {
      const { data = null, message = "", status_code = 200 } = payload ?? {};
      return {
        ...state,
        getOneLoading: false,
        getOneError: false,
        getOneData: data,
        getOneMessage: message,
        getOneStatusCode: status_code,
      };
    },
    onGetRealWeddingError: (state, { payload }) => {
      const { data = null, message = "", status_code = 400 } = payload ?? {};
      return {
        ...state,
        getOneLoading: false,
        getOneError: true,
        getOneData: data,
        getOneMessage: message,
        getOneStatusCode: status_code,
      };
    },
    onGetRealWeddingReset: (state) => ({
      ...state,
      getOneLoading: false,
      getOneError: false,
      getOneData: null,
      getOneMessage: "",
      getOneStatusCode: 0,
    }),
    onRealWeddingPost: (state) => ({
      ...state,
      postLoading: true,
      postError: false,
      postData: null,
      postMessage: "",
      postStatusCode: 0,
    }),
    onRealWeddingPostSuccess: (state, { payload }) => {
      const { data = null, message = "", status_code = 200 } = payload ?? {};
      return {
        ...state,
        postLoading: false,
        postError: false,
        postData: data,
        postMessage: message,
        postStatusCode: status_code,
      };
    },
    onRealWeddingPostError: (state, { payload }) => {
      const { data = null, message = "", status_code = 400 } = payload ?? {};
      return {
        ...state,
        postLoading: false,
        postError: true,
        postData: data,
        postMessage: message,
        postStatusCode: status_code,
      };
    },
    onRealWeddingPostReset: (state) => ({
      ...state,
      postLoading: false,
      postError: false,
      postData: null,
      postMessage: "",
      postStatusCode: 0,
    }),
  },
});

export const {
  onGetRealWeddings,
  onGetRealWeddingsSuccess,
  onGetRealWeddingsError,
  onGetRealWeddingsReset,
  onGetRealWedding,
  onGetRealWeddingSuccess,
  onGetRealWeddingError,
  onGetRealWeddingReset,
  onRealWeddingPost,
  onRealWeddingPostSuccess,
  onRealWeddingPostError,
  onRealWeddingPostReset,
} = realWeddingSlice.actions;

export default realWeddingSlice.reducer;
